import { Feature } from 'geojson';
import { round } from 'lodash';
import { useMemo } from 'react';

import ColorSwatches from '@/components/colorSwatches';
import SingleSlider from '@/components/slider/singleSlider';
import Typography from '@/components/typography';

import {
  CustomizeColorSwatchEnum,
  customizeSwatchConfig,
} from '../settingsConfig';
import { NewValues } from '.';

delete customizeSwatchConfig[CustomizeColorSwatchEnum.STRIPED]; // stripe pattern not needed for points

interface IProps {
  activeFeature: Feature | null;
  handleValueChange: (newValues: NewValues) => void;
}
const PointSettings = ({ activeFeature, handleValueChange }: IProps) => {
  const activeColorConfig = Object.values(customizeSwatchConfig).find(
    (val) => val.color === activeFeature?.properties?.color
  );

  const activeBorderColorConfig = Object.values(customizeSwatchConfig).find(
    (val) => val.color === activeFeature?.properties?.['border-color']
  );

  const activeOpacityConfig = useMemo(
    () => activeFeature?.properties?.opacity,
    [activeFeature?.properties?.opacity]
  );
  return (
    <>
      {activeColorConfig && (
        <ColorSwatches
          active={activeColorConfig}
          label="Color"
          swatchConfig={customizeSwatchConfig}
          onClick={(e) => handleValueChange({ color: e.color })}
        />
      )}
      <div className="flex flex-col gap-2">
        <Typography className="text-gray-70" variant="body2">
          Opacity
        </Typography>
        <SingleSlider
          defaultValue={round(activeOpacityConfig * 100)}
          handleChange={(val) => handleValueChange({ opacity: val / 100 })}
        />
      </div>
      {activeBorderColorConfig && (
        <ColorSwatches
          active={activeBorderColorConfig}
          label="Border Color"
          swatchConfig={customizeSwatchConfig}
          onClick={(e) => handleValueChange({ 'border-color': e.color })}
        />
      )}
    </>
  );
};

export default PointSettings;
